import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Vocal from "./pages/Vocal";
import WhatsApp from "./pages/WhatsApp";
import Audit from "./pages/Audit";
import Apropos from "./pages/Apropos";
import Contact from "./pages/Contact";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/receptionniste-ia" element={<Vocal />} />
          <Route path="/services/whatsapp-ia" element={<WhatsApp />} />
          <Route path="/audit-ia" element={<Audit />} />
          <Route path="/a-propos" element={<Apropos />} />
          <Route path="/contact" element={<Contact />} />

          {/* Redirects from old URLs */}
          <Route path="/vocal" element={<Navigate to="/services/receptionniste-ia" replace />} />
          <Route path="/whatsapp" element={<Navigate to="/services/whatsapp-ia" replace />} />
          <Route path="/audit" element={<Navigate to="/audit-ia" replace />} />
          <Route path="/apropos" element={<Navigate to="/a-propos" replace />} />

          {/* 404 catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
